<template>
    <b-container>
        <einladung-zeile v-for="einladung in einladungen" v-bind:key="einladung.EINPUBMSGID" :einladung="einladung" />
        <b-row class="ml-1 mr-1">
            <b-col lg="8" md="12">
                <b-row>
                    <b-col md="6" sm="12" v-for="item in itemsLeft" v-bind:key="item.name"  class="mt-3 mb-3">
                        <div class="home home-func" :class="'home-' + item.route">
                            <b-link class="title" :to="'/'+$i18n.locale+'/'+item.route">{{ $t(item.name) }}</b-link>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col lg="4" md="12">
                <b-row>
                    <b-col lg="12" md="6" sm="12" v-for="item in itemsRight" v-bind:key="item.name" class="mt-3 mb-3">
                        <div class="home home-org">
                            <b-link class="title" :to="'/'+$i18n.locale+'/' + item.route" v-if="cms || item.route === 'news/1'">{{ $t(item.name) }}</b-link>
                            <div class="title" v-if="! cms && item.route !== 'news/1'">{{ item.name }}</div>
                            <template v-for="ref in item.refs">
                                <!-- diese sind übersetzt  -->
                                <template  v-if="ref[$i18n.locale].url.length > 0">
                                    <!-- eine URL aus dem CMS wird als Target="_blank" ausgegeben -->
                                    <b-link v-bind:key="ref.id" class="news" :href="ref[$i18n.locale].url" target="_blank" v-if="ref[$i18n.locale].url.substr(0,1) !== '#'">{{ ref[$i18n.locale].name }}</b-link>
                                    <!-- eine interne verlinkung #Anchor aus dem CMS wird ohne Target ausgegeben- Firefox issue -->
                                    <b-link v-bind:key="ref.id" class="news" :href="ref[$i18n.locale].url"  v-if="ref[$i18n.locale].url.substr(0,1) === '#'">{{ ref[$i18n.locale].name }}</b-link>
                                </template>
                                <b-link v-bind:key="ref.id" class="news" :to="'/'+$i18n.locale+'/'+item.route+'/'+ref.id" v-if="ref[$i18n.locale].url.length === 0 && ref.id > 0">{{ ref[$i18n.locale].name }}</b-link>
                                <p v-bind:key="ref.id" class="news" v-if="ref[$i18n.locale].url.length === 0 && ref.id === 0" v-html="ref[$i18n.locale].name"></p>
                            </template>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-modal
            ref="oldUserModal"
            :title="$t('PIS_AlterBenutzerTitel')"
            ok-only
            hide-header-close
            no-close-on-esc
            no-close-on-backdrop>
            <p v-html="$t('PIS_AlterBenutzerText')"></p>
        </b-modal>
    </b-container>
</template>

<script>
import EinladungZeile from "./EinladungZeile.vue"
export default {
    name: "home",
    data() {
        return {
            masterDomain: this.$store.state.userStore.token.masterDomain
        };
    },
    computed: {
        itemsLeft() {
            return this.$store.state.navigationStore.home.filter(function(item) {
                return item.group === "left"
            });
        },
        itemsRight() {
            return this.$store.state.navigationStore.home.filter(function(item) {
                return item.group === "right"
            });
        },
        cms() {
            return this.$store.state.userStore.domain.modules.includes("CMS")
        },
        einladungen(){
            return this.$store.state.einladungenStore.einladungen.filter(einladung => einladung.EINPUBMSGDELAYED === false && einladung.EINPUBMSGREFUSED === false)
        }
    },
    created() {
        this.$nextTick(async function() {
            this.$store.dispatch("loadHome")
            this.$store.dispatch("loadEinladungen")
        });
    },
    mounted() {
        if (this.$store.state.userStore.domain.active === 0 && this.$t('PIS_AlterBenutzerText').length) {
            this.$store.commit("setDomainActive", -1);
            this.$refs.oldUserModal.show()
        }
    },
    components: {
        "einladung-zeile": EinladungZeile
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../public/css/tsmVars.scss";
#app {
  .home {
    width: 100%;
    height: 15em;
    a {
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .home > a {
    display: block;
  }
  .home > .title {
    height: 40%;
    padding-top: 1.5em;
    text-align: center;
    background-color: $tsmdunkel;
    opacity: 0.4;
    font-size: 1.3em;
    font-weight: bold;
    color: white;
  }
  .home > a.news {
    padding-top: 0.5em;
    text-align: center;
  }
  .home > p.news {
    padding: 0.5em;
  }
  .home-func {
    background-size: cover;
  }
  .home-org {
    background-color: $tsmnormal;
  }
  .home-analysen {
    background-image: url("/images/analysen.jpg");
  }
  .home-dokumente {
    background-image: url("/images/milchgeldabrechnung.jpg");
  }
  .home-zulagen {
    background-image: url("/images/zulagen.jpg");
  }
  .home-datenpakete {
    background-image: url("/images/datenpakete.jpg");
  }
}
</style>